import Button from 'assets/components/button/Button';
import ThemeButtonCircle from 'assets/components/button/themes/Theme.Button.Circle';
import ThemeButtonFloating from 'assets/components/button/themes/Theme.Button.Floating';
import Icon from 'assets/components/icon/Icon';
import { getLocales } from 'assets/locales/Locale';
import { useAuthStore } from 'assets/providers/authStore/Provider.AuthStore';
import { isEmpty } from 'lodash';
import { isMobile } from 'react-device-detect';
import { useClaimJobPaymentProvider } from '../Finance.ClaimJobPayment.Hooks';

export default function ClaimJobPaymentActions() {
  const { lang } = getLocales();
  const { listApi, exportToExcel } = useClaimJobPaymentProvider();
  const { permissions } = useAuthStore();

  return (
    <Button
      class={isMobile ? ThemeButtonFloating : ThemeButtonCircle}
      active
      media={<Icon class="fas-download" />}
      render={!isMobile && lang.export}
      onClick={exportToExcel}
      disabled={!permissions.CREATE_CLAIMJOBPAYMENT || isEmpty(listApi?.payload?.data)}
    />
  );
}
